<nav class="border-border-common-base flex h-full flex-col border-x">
  <div
    class="text-text-common-base border-border-common-base grid h-14 place-items-center border-y p-2"
  >
    <p-button
      class="w-full"
      label="Back"
      variant="text"
      severity="contrast"
      (click)="onBack()"
      styleClass="w-full justify-start!"
    >
      <svg-icon src="assets/icons/general/arrow-left.svg" />
    </p-button>
  </div>

  <ul class="flex w-full grow flex-col gap-2 overflow-auto p-2">
    @for (nav of navigationConfig(); track $index) {
      @if (navService.isCategory(nav)) {
        <ng-container *agHasPermissionAny="nav.categoryPermissions">
          <li class="mb-2 mt-4 px-2">
            <span class="overlines-small uppercase text-text-common-base">
              {{ nav.categoryLabel }}
            </span>
          </li>

          @for (child of nav.categoryItems; track child.label) {
            <ng-container
              *ngTemplateOutlet="navNodeRenderer; context: { $implicit: child }"
            />
          }
        </ng-container>
      } @else {
        <ng-container
          *ngTemplateOutlet="navNodeRenderer; context: { $implicit: nav }"
        />
      }
    }
  </ul>
</nav>

<ng-template #navNodeRenderer let-nav>
  @if (navService.isNavList(nav)) {
    <ng-container *agHasPermissionAny="nav.permissions">
      <li>
        <app-navigation-item [navList]="nav" />

        @if (navService.isSelectedList(nav.label)) {
          <ul class="my-2 ml-8! flex flex-col">
            @for (navItem of nav.items; track navItem) {
              <ng-container *agHasPermission="navItem.permission">
                <li>
                  <app-navigation-item [navItem]="navItem" [isNested]="true" />
                </li>
              </ng-container>
            }
          </ul>
        }
      </li>
    </ng-container>
  }

  @if (navService.isNavItem(nav)) {
    <ng-container *agHasPermission="nav.permission">
      <li>
        <app-navigation-item [navItem]="nav" [isNested]="false" />
      </li>
    </ng-container>
  }
</ng-template>
